<template>
  <div class="privacypolicy-view">
    <h1 class="agreement-title">隐私政策</h1>
    <div class="agreement-content">
      <div class="agreement-content-text">
        <p><u>易软信息科技（惠州）有限公司</u>及其关联方（以下简称“我方”）作为<u>易趣软件网站</u>（以下简称本产品及相关服务）的运营者，深知个人信息对您的重要性，我方将按照法律法规的规定，保护您的个人信息及隐私安全。</p>
        <p>下文将帮您详细了解<u>我方如何收集、使用、共享、转让、披露和储存个人信息；帮您了解查询、访问、删除、更正、撤回授权个人信息的方式。其中，有关您个人信息权益的条款重要内容我方已用加粗、下划线等形式提示，请特别关注。</u></p>
        <p>下文将帮助您详细了解以下内容</p>
        <p><b>1. 定义</b></p>
        <p><b>2. 我方如何收集和使用个人信息</b></p>
        <p><b>3. 我方如何使用Cookie等同类技术</b></p>
        <p><b>4. 我方如何共享、转让、公开披露个人信息</b></p>
        <p><b>5. 我方如何存储个人信息</b></p>
        <p><b>6. 我方如何保护个人信息的安全</b></p>
        <p><b>7. 您如何管理您的个人信息</b></p>
        <p><b>8. 未成年人条款（或者：我方如何处理未成年人的信息）</b></p>
        <p><b>9. 隐私政策的修订和通知</b></p>
        <p><b>10. 其他</b></p>
        <p><b>11. 联系我方</b></p>
        <h2>1. 定义</h2>
        <h3>1.1 个人信息</h3>
        <p>以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
        <h3>1.2 个人敏感信息</h3>
        <p>是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。</p>
        <h3>2. 我方如何收集和使用个人信息</h3>
        <p>我方可能会收集和使用下列与您有关的信息，如果您拒绝提供，您将无法享受相关服务。这些功能包括：</p>
        <h4>2.1 帮助您完成注册、登录</h4>
        <p>（1）您可以通过手机号等创建帐号，并且您可以完善相关的网络身份识别信息（昵称、密码等其他您主动提供的信息）。</p>
        <p>（2）如果您使用使用第三方帐号登录、使用本产品及相关服务，您将授权我方获取您在第三方平台的部分信息（仅包含账号、头像、昵称等第三平台授权登录时显示会提供给我方的信息），用于绑定本产品及相关服务帐号。</p>
        <h4>2.2 保证产品功能的正常实现</h4>
        <p>为了保证服务的正常运行，我方需要收集以下信息：</p>
        <h5>2.2.1 设备信息</h5>
        <p>为了依据您的具体情况向您提供适配的服务，我方可能会收集您所使用的设备的相关硬件信息。</p>
        <h5>2.2.2 使用信息</h5>
        <p>为了记录服务使用情况，维护服务正常运行，当您使用我方提供的服务时，我方可能会收集您对服务的详细使用/运行情况，可能包括<u>浏览、点击、交易、访问日期和时间、操作日志信息、崩溃报告</u>等信息。</p>
        <h5>2.2.3 您主动提供的信息</h5>
        <p>针对您向我方主动提供的任何个人信息，我方都将采取严格的信息安全措施以保证您的信息安全，我方也仅会为了本隐私政策约定之目的而进行合理的使用，我方的使用行为绝不涉及未经过您允许的个人信息泄露行为。</p>
        <h4>2.3 发布与互动</h4>
        <h5>2.3.1 如果您主动使用了产品及相关服务中的信息发布功能，我方将收集您发布的信息，且可能会展示您的<u>账号信息、发布内容和信息。</u></h5>
        <h5>2.3.2 您知悉并同意，对于您在使用产品及/或服务的过程中提供的您的联系方式（例如：邮箱号码），我方在运营中可能会向其中的一种或多种发送多类通知，用于提供您可能感兴趣的服务、功能或活动等商业性信息、用户消息告知、身份验证、安全验证、用户使用体验调研等，但请您放心，如您不愿接受这些信息，您可以直接与我方联系进行退订。</h5>
        <h3>2.4 帮助您完成支付</h3>
        <p><b>请您注意，支付功能由与我方合作的第三方支付机构向您提供，我方会通过第三方支付机构收集您的支付状态以确认向您提供付费服务。</b>第三方支付机构可能需要收集您的姓名、银行卡类型及卡号、有效期及手机号码。</p>
        <h3>2.5 提供优质的售中、售后服务或解决与您可能产生的争议</h3>
        <p>（1）为了完成服务的购买、续费、升级，我方可能收集您的支付状态以及注册账号的使用情况。</p>
        <p>（2）当您联系我方要求提供售中、售后服务，或者要求我方处理与您存在的争议、纠纷时，我方可能需要您提供必要的信息以核验您的身份。</p>
        <p>（3）为了向您提供更优质的售中、售后服务，我方还有可能使用您与我方取得联系时主动提供的其他各项信息。</p>
        <h3>2.6 提供网络信息安全保障</h3>
        <p>为保证您使用我方提供的服务的安全性、稳定性，更好地预防和应对网络欺诈、网络病毒、网络数据的扒取、网络侵入等问题，保护广大用户的个人信息安全、人身财产安全免于侵害，我方可能使用您的个人信息、交易信息、设备信息、使用信息来帮助我方判断您的个人账号安全与否（例如是否存在账号共享、非官方账号等情况）以及账号的使用情况是否会影响我方产品及相关服务的稳定性。</p>
        <h3>2.7 优化产品</h3>
        <p>我方会采取脱敏、去标识化等方式对您的信息进行综合统计、分析加工，以便于我方评估、改善或设计产品、服务及运营活动。</p>
        <h3>2.8 收集、使用个人信息目的变更</h3>
        <p>请您了解，随着我方业务的发展，可能会对本产品及相关服务的功能和提供的服务有所调整变化。原则上，当新功能或服务与我方当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我方收集、使用您的个人信息，会再次进行告知，并征得您的同意。</p>
        <p><b>但请您理解，由于我方向您提供的服务是不断更新和发展的。如您选择使用了前述说明中尚未涵盖的其他服务，基于该服务我方需要收集您的信息的，我方会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集的范围和目的，并征得您的同意。我方会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如果您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我方的提供的其他服务。</b></p>
        <h3>2.9 依法无需征得同意收集和使用的个人信息</h3>
        <p>请您理解，在下列情形中，根据法律法规及相关国家标准，我方收集和使用您的个人信息无需征得您的授权同意：</p>
        <p>（1）与国家安全、国防安全直接相关的；</p>
        <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
        <p>（5）所收集的您的个人信息是您自行向社会公众公开的；</p>
        <p>（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p>（7）根据您的要求签订或履行合同所必需的；</p>
        <p>（8）用于维护产品及相关服务的安全稳定运行所必需的，例如发现、处置产品及相关服务的故障；</p>
        <p>（9）为合法的新闻报道所必需的；</p>
        <p>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
        <p>（11）法律法规规定的其他情形。</p>
        <p><b>特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份（包括通过脱敏、去标识化处理后无法单独或结合其他信息识别到您的个人身份的信息），其不属于法律意义上您的个人信息。</b></p>
        <h2>3. 我方如何使用Cookie等同类技术</h2>
        <p>Cookie和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用本产品及相关服务时，我方可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集、标识您访问、使用本产品时的相关信息。我方承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我方使用Cookie主要为了实现以下功能或服务：</p>

        <h3>3.1 保障产品与服务的安全、高效运转</h3>
        <p>我方可能会设置认证与保障安全性的Cookie 或匿名标识符，使我方确认您是否安全使用服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我方改进服务效率，提升登录和响应速度。</p>
        <h3>3.2 为您推荐、展示、推送您更感兴趣的内容或帐号</h3>
        <p>我方可能会利用此类技术了解您的偏好和使用习惯，进行数据分析，以改善产品服务、推荐用户感兴趣的功能。</p>
        <h3>3.3 探索更好的服务方式</h3>
        <p>在本产品及相关服务的分享页中，我方可能会使用Cookie对浏览活动进行记录，用于向您推荐信息和排查崩溃、延迟的相关异常情况以及探索更好的服务方式。</p>
        <h2>4. 我方如何共享、转让、公开披露个人信息</h2>
        <h3>4.1 共享</h3>
        <p>（1）我方可能会按照法律法规的要求或强制性的政府要求或司法裁定等，与相关的第三方共享您的个人信息。</p>
        <p>（2）在征得明确同意的情况下共享：征得您的明确同意后，我方可能会与其他方共享您的个人信息。</p>
        <p>（3）与关联公司间共享：为便于我方向您提供产品或服务，推荐您可能感兴趣的信息，识别使用异常，保护我方关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我方的关联公司和/或其指定的服务提供商共享。我方只会共享必要的个人信息，且受本隐私权政策中所声明目的的约束，如果我方共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。</p>
        <p>（4）与授权合作伙伴共享：我方可能委托授权合作伙伴为您提供某些服务或代表我方履行某些职能，我方仅会出于本隐私政策中明确、合法、正当的目的共享您的信息，且授权合作伙伴不得将该等信息用于其他任何目的。</p>
        <p>目前，我方的授权合作伙伴包括以下类型：</p>
        <p>①广告、分析服务类的授权合作伙伴。未得到您的授权的情况下，我方不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。这些合作伙伴可能会帮助我方处理一些用户数据，但我方不会向其提供您的个人身份信息。我方可能将一些经过匿名化处理的数据共享给合作伙伴，这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我方委托的广告服务或决策建议。</p>
        <p>②供应商、服务提供商和其他合作伙伴。该等合作伙伴向我方提供数据存储等技术基础设施服务、收集分析我方的服务使用情况、并协助我方提供客户服务、提供支付便利或展开研究和调查，该等供应商、服务提供商和其他合作伙伴将仅在合法合规的前提下收集/获得您的个人信息。</p>
        <p>我方会对合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并要求其按照本隐私政策来处理可能获得的个人信息。</p>

        <h3>4.2 转让</h3>
        <p>（1）我方不会转让您的个人信息给任何其他第三方，除非征得您的明确同意。</p>
        <p>（2）随着我方业务的持续发展，我方将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我方将按照法律法规及不低于本隐私政策所载明的安全标准，要求继受方保护您的个人信息，否则我方将要求继受方重新征得您的授权同意。</p>
        <h3>4.3 公开披露</h3>
        <p>（1）我方不会公开披露您的信息，除非遵循国家法律法规规定或者征得您的同意。我方公开披露您的个人信息将采用符合行业内标准的安全保护措施。</p>

        <h3>4.4 委托处理</h3>
        <p>为了提升信息处理效率，降低信息处理成本，或提高信息处理准确性，我方有可能会委托有能力的我方的关联公司或其他专业机构代表我方来处理信息。我方会要求受托公司严格遵守保密义务，禁止其将这些信息用于您未授权的用途。我方承诺，在委托关系解除时，受托公司将不再保存有关个人信息。</p>
        <h3>4.5 共享、转让、公开披露的个人信息时事先征得授权同意的例外</h3>
        <p>请您理解，在下列情形中，根据相关法律法规及国家标准，我方共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
        <p>（1）与国家安全、国防安全直接相关的；</p>
        <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>（3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法直接相关的；</p>
        <p>（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
        <p>（5）您自行向社会公众公开的个人信息；</p>
        <p>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p>（7）与我方履行法律法规规定的义务相关的。</p>
        <p>请知悉，若我方对个人信息采取技术措施和其他必要措施进行处理，设计的数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</p>

        <h2>5. 我方如何存储个人信息</h2>
        <h3>5.1 存储地点</h3>
        <p>我方依照中华人民共和国相关法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我方不会将上述信息传输至境外，如果我方向境外传输，我方将会遵循相关国家规定或者征求您的同意。</p>
        <h3>5.2 存储期限</h3>
        <p>我方仅在达成本政策所述目的所需的期限内保留您的个人信息。超出必要期限后，我方将对您的个人信息进行删除或匿名化处理，但法律有强制留存要求的除外。在下列情况下，我方可能因需符合法律要求，更改个人信息的存储时间：</p>
        <p>（1）为遵守适用的法律法规规定，例如，《中华人民共和国网络安全法》第二十一条第三款要求监测、记录网络运行状态、网络安全事件的技术措施的网络日志留存不得少于六个月；《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；</p>
        <p>（2）为遵守法院判决、裁定或其他法律程序的规定；</p>
        <p>（3）为遵守政府机关或法定授权组织的要求；</p>
        <p>（4）为执行平台协议或本政策、维护社会公共利益，保护公司及公司关联公司、其他用户或雇员的人身安全或其他合法权益所合理必需的用途。</p>

        <h2>6. 我方如何保护个人信息的安全</h2>
        <h3>6.1 安全措施</h3>
        <p>我方非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。</p>
        <h3>6.2 安全保护机制</h3>
        <p>我方会使用加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。</p>
        <h3>6.3 应急处理预案</h3>
        <p>我方会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失）后，我方将按照法律法规的要求，及时向您告知，难以逐一告知时，我方会采取合理、有效的方式发布公告。同时，我方还将按照相关监管部门要求，上报用户信息安全事件的处置情况。</p>
        <h3>6.4 例外告知</h3>
        <p>（1）请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我方将尽力确保您提供给我方的个人信息的安全性。</p>
        <p>（2）您一旦离开本产品及相关服务，浏览或使用其他网站、服务及内容资源，我方将没有能力和直接义务保护您在本产品及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于本产品及相关服务的链接或引导。</p>
        <h2>7. 您如何管理您的个人信息</h2>
        <h3>7.1 账号信息</h3>
        <p>您可以根据网站、产品内的指引，查询、访问、删除、更正您的个人信息、执行账号注销，如您对此有任何疑问，您可以通过我方提供的官方联系方式与我方联系，我方将在十五个工作日内响应并处理您的问题。</p>
        <h3>7.2 修改初始注册信息</h3>
        <p>出于安全性和身份识别的考虑，您可能无法自主修改注册时提交的某些初始注册信息（如实名认证后信息）；如您确有必要修改该类信息，请您联系我方，我方将尽快审核所涉问题，并由专人验证您的用户身份后及时予以回复。</p>
        <h3>7.3 投诉举报</h3>
        <p>您可以按照我方公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以通过我方提供的官方联系方式向我方发起投诉或举报。我方核查后会在30日内反馈您的投诉与举报。</p>

        <h2>8. 未成年人条款</h2>
        <p>我方深知保护儿童（根据《儿童个人信息网络保护规定》的规定，下文的儿童均指未满十四周岁的未成年人）个人信息安全和隐私的重要性。我方另行设置了《儿童隐私保护政策》，本协议与《儿童隐私保护政策》不符的，以《儿童隐私保护政策》为准。</p>
        <p>（1）我方处理未成年人个人信息时，将遵循合法、正当和必要的原则。</p>
        <p>（2）若您是未成年人，在使用本产品及相关服务及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。</p>
        <p>（3）我方根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息；如果我方发现在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。</p>
        <p>（4）若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我方联系。</p>

        <h2>9. 隐私政策的修订和通知</h2>
        <p>（1）为了给您提供更好的服务，本产品及相关服务将不时更新与变化，我方会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我方不会削减您依据当前生效的本隐私政策所应享受的权利。</p>
        <p>（2）本隐私政策更新后，我方会在本产品及相关服务发出更新版本，并通过其他适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本。</p>

        <h2>10. 其他</h2>
        <h3>10.1 隐私政策查看</h3>
        <p>您可以在本产品及相关服务的对应页面内查看本隐私政策。我方鼓励您在每次使用本产品及相关服务时都查阅我方提供的隐私政策。</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.privacypolicy-view {
  width: 1200px;
  margin: 0 auto;
  min-height: 50vh;
  margin-top: 40px;
  margin-bottom: 80px;

  .agreement-title {
    text-align: center;
    text-wrap-mode: wrap;
    text-align: center;
    margin-top: 15px;
  }

  .agreement-content {
    text-wrap-mode: wrap;
    text-align: justify;

    p {
      font-size: 18px;
      line-height: 30px;
      margin-bottom: 18px;
      margin-top: 18px;
    }
  }
}

</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})
</script>

